import React from 'react';
import Stats from '../../../components/Global/BannerCard/Stats/Stats';
import LIRC from '../../../components/Global/BannerCard/LIRC/LIRC';
import ExpertiseSection from '../../../components/Global/BannerCard/Expertise/ExpertiseSection';
import THC from '../../../components/Global/BannerCard/T&HC/THC';
import MakeTheShift from '../../../components/MakeTheShift/MakeTheShift';
import CyientGrid from '../../../components/Global/BannerCard/CyientGrid/CyientGrid';



const Innovation = () => {
  return (
    <div>
      <Stats />
      <LIRC />
      <CyientGrid />
      <ExpertiseSection />
      <THC />
      <MakeTheShift />
    </div>
  );
};

export default Innovation;
